module.exports = __webpack_public_path__ + "img/cebuana_lhuillier.70cbf9d9.png";